/**
 * Хранилище браузера для прогресса обучения: в приватном окне, при запрете сайта или
 * переполнении доступ бросает исключение. Здесь оно превращается в признак
 * недоступности -- обучение продолжает работать в памяти.
 */

export function readLocal(key: string): { value: string | null; available: boolean } {
	try {
		return { value: window.localStorage.getItem(key), available: true };
	} catch {
		return { value: null, available: false };
	}
}

export function writeLocal(key: string, value: string): boolean {
	try {
		window.localStorage.setItem(key, value);
		return true;
	} catch {
		return false;
	}
}
